import { c as _c } from "react/compiler-runtime";
import EditTriggerWrapper from 'modules/automation-rules/triggers/components/edit-triggers/components/edit-trigger-wrapper';
import EmailSelect from 'modules/automation-rules/triggers/components/edit-triggers/components/trigger-email-item/components/email-select';
import { EditTriggerItemInterface } from 'modules/automation-rules/triggers/components/edit-triggers/types/edit-trigger-item-interface';
import { AutomationRuleTriggersDataEnum } from 'modules/automation-rules/triggers/enums/trigger-enum';
import { TriggerEmailEditInterface } from 'modules/automation-rules/triggers/types/automation-rule-triggers-edit-interface';
export interface TriggerEmailItemProps extends EditTriggerItemInterface<TriggerEmailEditInterface> {}
const TriggerEmailItem = t0 => {
  const $ = _c(16);
  const {
    triggers,
    trigger,
    idx,
    errors,
    setRules,
    onDelete,
    isStatic
  } = t0;
  let t1;
  if ($[0] !== idx || $[1] !== onDelete) {
    t1 = () => onDelete(idx);
    $[0] = idx;
    $[1] = onDelete;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== errors || $[4] !== idx || $[5] !== isStatic || $[6] !== setRules || $[7] !== trigger.id || $[8] !== trigger.mailing.currentEmail?.subject || $[9] !== trigger.mailing.id || $[10] !== triggers) {
    t2 = t3 => {
      const {
        data,
        onOpen
      } = t3;
      return <EmailSelect isStatic={isStatic} emailData={data.emailData} onChange={data_0 => setRules(prev => ({
        ...prev,
        triggers: triggers.map((el, i) => {
          if (idx === i) {
            return {
              ...el,
              mailing: {
                id: data_0
              }
            };
          } else {
            return el;
          }
        })
      }))} errors={errors} triggerId={trigger.id} mailingId={trigger.mailing.id} onOpen={() => onOpen(AutomationRuleTriggersDataEnum.email)} subject={trigger.mailing.currentEmail?.subject} />;
    };
    $[3] = errors;
    $[4] = idx;
    $[5] = isStatic;
    $[6] = setRules;
    $[7] = trigger.id;
    $[8] = trigger.mailing.currentEmail?.subject;
    $[9] = trigger.mailing.id;
    $[10] = triggers;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== t1 || $[13] !== t2 || $[14] !== trigger) {
    t3 = <EditTriggerWrapper trigger={trigger} onDelete={t1}>{t2}</EditTriggerWrapper>;
    $[12] = t1;
    $[13] = t2;
    $[14] = trigger;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  return t3;
};
export default TriggerEmailItem;